import { Button, Form, Input, Modal, Select } from "antd";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

export default function SupportModal(props) {
  const { setOpenSupportModal, openSupportModal } = props;

  const [form] = Form.useForm();
  const [allLeagueListasObject, setAnyLeagueListasObject] = useState();

  const [leaguesList, setLeaguesList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [seasonList, setSeasonList] = useState([]);
  const [tiersList, setTiersList] = useState([]);

  //Various Selected Filter
  const [league, setLeague] = useState("Sunday League");
  const [tier, setTier] = useState("");
  const [season, setSeason] = useState("");
  const [filterdata, setFilterData] = useState([]);
  const onSubmit = async (values) => {
    let v2 = seasonList?.find((item) => item?.value=== season);
    const v3 = matchteamList?.find(item=>matchTeam===item?._id)
    const v4 = v3?.home?.name + ' vs ' + v3?.away?.name + ' - ' + dayjs(v3?.data).format('DD MMM, YYYY')
    const submitIssue = await axios.post(
      `${env?.API_ENDPOINT_URL}/settings/customer-support-mail`,{...values,league,season:v2?.label,match:v4}
    );
    console.log(v2,submitIssue)
    setOpenSupportModal(false);
    form.resetFields();
  };
  const { Option } = Select;
  const getLeagueNameFromAnyLeagueList = (data) => {
    let leagueListName = {};
    // eslint-disable-next-line no-unused-vars
    let v1 = data?.forEach((item) => {
      leagueListName[item._id] = item.name;
    });
    return leagueListName;
  };

  //function called on season change to set league list and league for league drop down
  const updateLeagueListOnSeasonChangefromFilterData = (seasonid) => {
    console.log("at line 35");
    const index = filterdata?.findIndex((item) => item?._id === seasonid);
    const leagueslistlocal = filterdata?.[index]?.leagues?.map((item) => {
      return { value: item?.league, name: allLeagueListasObject[item?.league] };
    });
    setLeague(allLeagueListasObject[filterdata?.[index]?.leagues?.[0]?.league]);
    form.setFieldsValue({
      league: allLeagueListasObject[filterdata?.[index]?.leagues?.[0]?.league],
    });
    setLeaguesList([...leagueslistlocal]);

    // updating tier as league is changed
    const tierlistlocal = filterdata?.[index]?.leagues?.[0]?.tiers?.map(
      (item) => item.tier
    );
    setTier(filterdata?.[index]?.leagues?.[0]?.tiers?.[0]?.tier);
    form.setFieldsValue({
      tier: filterdata?.[index]?.leagues?.[0]?.tiers?.[0]?.tier,
    });
    console.log(tierlistlocal, "tierlistlocal");
    if (tierlistlocal?.length === 1) {
      setTiersList([
        ...tierlistlocal
      ]);
    } else {
      setTiersList([
        ...tierlistlocal
      ]);
    }
  };
  //function called on initial load to set tier list and tier for tier drop down
  const updateTierListOnLeagueChangefromFilterData = (leagueid) => {
    console.log("at line 60");
    const seasonindex = filterdata?.findIndex((item) => item?._id === season);
    const leagueindex = leaguesList?.findIndex(
      (item) => item?.name === leagueid
    );
    const leagueslistlocal = filterdata?.[seasonindex]?.leagues?.map((item) => {
      return { value: item?.league, name: allLeagueListasObject[item?.league] };
    });
    setLeague(
      allLeagueListasObject[
        filterdata?.[seasonindex]?.leagues?.[leagueindex]?.league
      ]
    );
    form.setFieldsValue({
      league:
        allLeagueListasObject[
          filterdata?.[seasonindex]?.leagues?.[leagueindex]?.league
        ],
    });
    setLeaguesList([...leagueslistlocal]);

    // updating tier as league is changed
    const tierlistlocal = filterdata?.[seasonindex]?.leagues?.[
      leagueindex
    ]?.tiers?.map((item) => item.tier);
    setTier(
      filterdata?.[seasonindex]?.leagues?.[leagueindex]?.tiers?.[0]?.tier
    );
    form.setFieldsValue({
      tier: filterdata?.[seasonindex]?.leagues?.[leagueindex]?.tiers?.[0]?.tier,
    });
    setTiersList([
      ...tierlistlocal
    ]);
  };
  //function called on initial load to set season list and season for season drop down
  const getSeasonListOninitialLoadfromFilterData = (data) => {
    console.log(data, "datads");
    const seasonlistlocal = data?.map((item) => {
      return { value: item?._id, label: item?.name };
    });
    //sort((a,b)=>(a?.is_active>b?.is_active)?-1:(a?.is_active>b?.is_active)?1:-1)?.

    setSeason(data?.[0]?._id);
    form.setFieldsValue({ season: data?.[0]?._id });
    setSeasonList([...seasonlistlocal]);
  };
  //function called on initial load to set league list and league for league drop down
  const getLeagueListOninitialLoadfromFilterData = (data, leagueListName) => {
    const dat = [...data];
    const leagueslistlocal = dat?.[0]?.leagues?.map((item) => {
      //sort((a,b)=>(a?.is_active>b?.is_active)?-1:(a?.is_active>b?.is_active)?1:-1)?.
      return { value: item?.league, name: leagueListName[item?.league] };
    });
    setLeague(leagueListName[dat?.[0]?.leagues?.[0]?.league]); //sort((a,b)=>(a?.is_active>b?.is_active)?-1:(a?.is_active>b?.is_active)?1:-1)?.
    form.setFieldsValue({
      league: leagueListName[dat?.[0]?.leagues?.[0]?.league],
    }); //sort((a,b)=>(a?.is_active>b?.is_active)?-1:(a?.is_active>b?.is_active)?1:-1)?.
    setLeaguesList([...leagueslistlocal]);
  };
  //function called on initial load to set tier list and tier for tier drop down
  const getTierListOninitialLoadfromFilterData = (data) => {
    const tierlistlocal = data?.[0]?.leagues?.[0]?.tiers?.map(
      (item) => item.tier
    );
    //setTier(data?.[0]?.leagues?.[0]?.tiers?.[0]?.tier)
    //form.setFieldsValue({tier:data?.[0]?.leagues?.[0]?.tiers?.[0]?.tier})
    if (tierlistlocal?.length === 1) {
      setTiersList([...tierlistlocal]);
    } else {
      setTiersList([
        ...tierlistlocal
      ]);
    }
    //setTiersList([...tierlistlocal,(tierlistlocal?.length===1)?undefined:'Any'])//,(current==='stats' || current==='scores' || current==='schedule')?'Any':undefined
  };
  //Function called to get filter data with season>>league>>tier object
  const getFilters = async () => {
    const response = await axios.get(
      `${env?.API_ENDPOINT_URL}/settings/getfilters`
    );
    const filtersinfo = response?.data?.filtersInfo?.filter(item=>item?.is_active && item?.leagues?.filter(items=>items?.status!=='Completed')?.length)
    setFilterData([...(filtersinfo ?? [])]);
    const leaguesResponse = await axios.get(
      `${env?.API_ENDPOINT_URL}/settings/leagueslist`
    );
    const leagueListName = getLeagueNameFromAnyLeagueList(
      leaguesResponse?.data
    );
    setAnyLeagueListasObject({ ...leagueListName });
    getLeagueListOninitialLoadfromFilterData(
      filtersinfo ?? [],
      leagueListName
    );
    getSeasonListOninitialLoadfromFilterData(filtersinfo ?? []);
    getTierListOninitialLoadfromFilterData(filtersinfo ?? []);
  };
  useEffect(() => {
    getFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(tiersList, "tiersListtiersList");
    if (tiersList?.length === 1) {
      console.log("set index value");
      setTier(tiersList?.[0]);
      form.setFieldsValue({ tier: tiersList?.[0] });
    } else {
      setTier("");
      form.setFieldsValue({ tier: "" });
    }
    // if(current==='stats' || current==='scores' || current==='schedule') {
    // } else {
    //   setTier(tiersList?.[0])
    //   form.setFieldsValue({tier:tiersList?.[0]})
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [season, league]);
  const [teamList, setTeamList] = useState([]);
  const [matchteamList, setmatchteamList] = useState([]);
  const [team, setTeam] = useState("");
  const [matchTeam, setMatchTeam] = useState("");
  console.log(teamList, "teamListteamList");
  const getTeams = async (payload) => {
    const teamList = await axios.post(
      `${env?.API_ENDPOINT_URL}/settings/teamlist`,
      payload
    );
    setTeamList([...(teamList?.data?.data ?? [])]);
  };
  const getMatchList = async () => {
    const {league,season,tier} = {...form.getFieldsValue()}
    const teamid = teamList.find(item=>item?.name===team)?._id
    console.log(form.getFieldsValue(),'form.getFieldsValue()',leaguesList)
    console.log(teamid,'teamidteamid',leaguesList.find(item=>item?.name===league)?.value,season,tier)
    const teamListres = await axios.post(
      `${env?.API_ENDPOINT_URL}/settings/matcheslistteam`,
      {teamid:teamid,leagueid:leaguesList.find(item=>item?.name===league)?.value,season,tier}
    );
    console.log(teamListres?.data?.data,'teamListres')
    const finalMatchesData = teamListres?.data?.data?.map(item=>{return {...item,
      home: item?.homet,
      away: item?.awayt
      //home:teamList?.find(items=>items?._id===item?.homeTeam),
      //away:teamList?.find(items=>items?._id===item?.awayTeam)
    }})
    // setTeamList([...(teamList?.data?.data ?? [])]);
    console.log(finalMatchesData,'teamListres')
    setmatchteamList([...(finalMatchesData??[])])
  };
  useEffect(()=>{
    if(team) getMatchList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[team])
  useEffect(() => {
    if (season && tier && league) {
      const v1 = leaguesList.find((item) => item?.name === league);
      console.log(v1, "v1", typeof tier);
      //const tiernum = (typeof(parseInt(tier))==="number")?tier:undefined
      const payload = { season, league: v1?.value, tier };
      getTeams(payload);
    }
  }, [season, league, tier, leaguesList]);

  return (
    <Modal
      open={openSupportModal}
      onCancel={() => setOpenSupportModal(false)}
      okText="Submit"
      title="Report your issue to our support team"
      maskClosable={false}
      footer={null}
    >
      <b>Attention:</b> If our support team emails you about the stats update issue and there's no response within 48 hours, the ticket will be closed. It cannot be reopened!
      <Form
        form={form}
        onFinish={onSubmit}
        wrapperCol={{
          span: 18,
        }}
        labelCol={{
          span: 6,
        }}
        labelAlign="left"
        onS
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please input your name",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please input your Email",
            },
          ]}
        >
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item name="season" label="Season"
          rules={[
            {
              required: true,
              message: "Please input your season",
            },
          ]}>
          <Select
            placeholder="Season"
            onChange={(e) => {
              setSeason(e);
              updateLeagueListOnSeasonChangefromFilterData(e);
            }}
            value={season}
          >
            {seasonList?.map((state) => (
              <Option key={state?.value} value={state?.value}>
                {state?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="league" label="League"
          rules={[
            {
              required: true,
              message: "Please input your league",
            },
          ]}>
          <Select
            placeholder="League"
            onChange={(e) => {
              setLeague(e);
              updateTierListOnLeagueChangefromFilterData(e);
            }}
            value={league}
          >
            {leaguesList?.map((state) => (
              <Option key={state?.name} value={state?.name}>
                {state?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="tier" label="Tier"
          rules={[
            {
              required: true,
              message: "Please input your tier",
            },
          ]}>
          <Select
            placeholder="Tier"
            onChange={setTier}
            value={tier}
            disabled={!Boolean(tiersList?.[0])}
          >
            {tiersList
              ?.sort((a, b) => (parseInt(a) > parseInt(b) ? 1 : -1))
              .map((state) => (
                <Option key={state} value={state}>
                  {Boolean(tiersList?.[0]) ? state : "No Tier"}
                </Option>
              ))}
          </Select>
        </Form.Item>
        <Form.Item name="team" label="Team"
          rules={[
            {
              required: true,
              message: "Please input your team",
            },
          ]}>
          <Select
            placeholder="Team"
            onChange={setTeam}
            value={team}
            disabled={!Boolean(teamList?.[0])}
          >
            {teamList?.map((state) => (
              <Option key={state?.name} value={state?.name}>
                {state?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="match" label="Match"
          rules={[
            {
              required: true,
              message: "Please Select a Match",
            },
          ]}>
          <Select
            placeholder="Match"
            onChange={setMatchTeam}
            value={matchTeam}
            disabled={!Boolean(teamList?.[0])}
          >
            {matchteamList?.map((state) => (
              <Option key={state?._id} value={state?._id}>
                {state?.home?.name} vs {state?.away?.name} - {dayjs(state?.date).format('DD MMM, YYYY')}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
              message: "Please input your issue description",
            },
          ]}
        >
          <Input.TextArea placeholder="Description" />
        </Form.Item>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Button onClick={() => setOpenSupportModal(false)}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
}
